import { useEffect, useRef, useState } from "react"

type Timeout = ReturnType<typeof globalThis.setTimeout>

export const useDebounce = <Func extends AnyFunction>(callback: Func, delay = 0) => {
	const timeoutRef = useRef<Timeout | undefined>(undefined)

	return (...args: Parameters<Func>) => {
		clearTimeout(timeoutRef.current as Timeout)
		timeoutRef.current = setTimeout(() => {
			callback(...args)
		}, delay)
	}
}

export const useDebouncedValue = <T>(value: T, delay: number): T => {
	const [debouncedValue, setDebouncedValue] = useState<T>(value)

	useEffect(() => {
		const timer = setTimeout(() => {
			setDebouncedValue(value)
		}, delay)

		return () => clearTimeout(timer)
	}, [value, delay])

	return debouncedValue
}
